import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { TableSortArrow } from '../../../../../../utils/IconComp';
import { GetDate } from '../../../../../../utils/Show';
import { mkRelativeUrl } from '../../../../../../utils/URL';
import cn from '../../../../../../utils/cn';
// handleReload
function TableRow({ item }) {
    const navigate = useNavigate();
    // const { setConfirm, setMessage, setTemplateLoading } = useTemplate();
    // const [showMenu, setShowMenu] = useState(false);
    // const handleShowInstMenu = () => {
    //     setShowMenu((d) => !d);
    // };
    const handleView = (id) => {
        navigate(mkRelativeUrl(`/billing/invoices/${id}/info`));
    };

    // const handleMakeInitiate = () => {
    //     setConfirm({
    //         text: 'Are you sure you want to make this item initiate?',
    //         textAction: 'Mark as Initiate',
    //         clickAction: () => {
    //             setTemplateLoading(true);
    //             ApiMakeInitiateItem(item?.invoiceId, item?.invoiceItemId)
    //                 .then(({ title }) => {
    //                     setMessage({ type: 'success', text: title });
    //                     setConfirm(null);
    //                     handleReload();
    //                     setTemplateLoading(false);
    //                 })
    //                 .catch((err) => {
    //                     setTemplateLoading(false);
    //                     setMessage({ type: 'error', text: err.toString(0) });
    //                 });
    //         }
    //     });
    // };
    return (
        <tr
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.invoiceItemId}</span>
            </td>
            <td onClick={() => handleView(item?.invoiceId)}>
                <span className="group-hover:text-secondary group-hover:font-medium cursor-pointer hover:underline text-ellipsis block w-full overflow-hidden">
                    {item?.invoiceId}
                </span>
            </td>
            <td>
                <span className="capitalize">{item?.productType}</span>
            </td>
            <td className="group-hover:font-medium group-hover:text-secondary hover:underline cursor-pointer">
                <Link
                    to={mkRelativeUrl(
                        `/agency/${item?.customerInfo?.agencyId}/customers/${item?.customerInfo?.id}/info`
                    )}
                    className="flex flex-col gap-1"
                >
                    <span>{item?.customerInfo?.organization}</span>
                    <span className="text-xs text-primary-500 truncate max-w-[200px]">
                        {item?.customerInfo?.primaryEmail}
                    </span>
                </Link>
            </td>
            <td>
                <span>{item?.serviceName || '----'}</span>
            </td>
            <td>
                <span>{item?.packageName || '----'}</span>
            </td>
            <td
                onClick={() => navigate(mkRelativeUrl(`/customers/${item?.user?.id}/info`))}
                className="cursor-pointer group-hover:text-secondary hover:underline"
            >
                <span className="group-hover:font-medium text-ellipsis block w-full overflow-hidden">
                    {item?.user?.organization || '-----'}
                </span>
            </td>
            <td>
                <span className="text-ellipsis block w-full overflow-hidden">
                    {item?.user?.primaryEmail || '----'}
                </span>
            </td>

            <td
                className={cn('text-center', {
                    '*:!font-medium': item?.expireSoon,
                    '*:text-error': item?.expireDay <= 30,
                    '*:text-yellow-400': item?.expireDay <= 45 && item?.expireDay > 30
                })}
            >
                <span>{GetDate(item?.timeUpdated) || 'No End Date'}</span>
            </td>
            <td className="text-center capitalize">
                <span className={item?.status === 'active' ? 'text-secondary' : 'text-warning'}>
                    {item?.status}
                </span>
            </td>
            {/* <td className="text-center">
                <span>
                    <div className="flex flex-row w-full justify-end relative">
                        <OptionButton onClick={handleShowInstMenu} />
                        <InstOption showMenu={showMenu} setShowMenu={setShowMenu}>
                            {item?.status === 'pending' && (
                                <button type="button" onClick={() => handleMakeInitiate()}>
                                    Mark as Initiate
                                </button>
                            )}
                        </InstOption>
                    </div>
                </span>
            </td> */}
        </tr>
    );
}
function TableHeader({ sortBy, sortedColumn, sortedHandler }) {
    return (
        <thead>
            <tr>
                <th scope="col" onClick={() => sortedHandler('id')}>
                    <span className="">ID</span>
                    {/* <TableSortArrow name="id" sortBy={sortBy} sortedColumn={sortedColumn} /> */}
                </th>
                <th scope="col" onClick={() => sortedHandler('invoice-id')}>
                    <span className="">Invoice ID</span>
                    {/* <TableSortArrow name="invoice-id" sortBy={sortBy} sortedColumn={sortedColumn} /> */}
                </th>
                <th scope="col">
                    <span>Product Type</span>
                </th>
                <th scope="col" className="!text-left w-42">
                    <span>Customer Info</span>
                </th>
                <th scope="col">
                    <span>Service Name</span>
                </th>
                <th scope="col" className="!cursor-default">
                    <span>Package Name</span>
                </th>
                <th scope="col">
                    <span>Customer Info.</span>
                </th>
                <th scope="col" className="!cursor-default">
                    <span>Email</span>
                </th>

                <th
                    scope="col"
                    className="!w-40 text-center"
                    onClick={() => sortedHandler('service-update')}
                >
                    <span>Service Update</span>
                    <TableSortArrow
                        name="service-update"
                        sortBy={sortBy}
                        sortedColumn={sortedColumn}
                    />
                </th>
                <th scope="col" className="w-30 text-center">
                    <span data-tooltip-id="tblTooltip" data-tooltip-content="Service Status">
                        Status
                    </span>
                </th>
                {/* <th scope="col">#</th> */}
            </tr>
        </thead>
    );
}

function PendingTableWeb({ data }) {
    if (data?.length === 0) {
        return null;
    }
    return (
        <div className="agency_info_service_pending_page_table pb-40 overflow-x-auto">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader />
                <tbody>
                    {data?.map((item) => (
                        <TableRow key={item?.invoiceItemId} item={item} />
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default PendingTableWeb;
